module.exports = __webpack_public_path__ + "media/images/bus/conditions/TV-54c60c2b714990ac12ab46c50ee31f8b.svg";